export default {
  metadata: {
    version: '1.0.0',
    id: 'avatar-1.0.0',
    name: 'JDSAvatar',
    description:
      'Avatars are used to show a thumbnail representation of an individual or business in the interface.',
    usage:
      'Avatars can either be custom images uploaded by users, or default themed images, or automatically populated user initials.'
  },
  hierarchy: {
    container: [
      'jds_image',
      'jds-text',
      {
        'jds-icon-container': ['jds-icon']
      }
    ]
  },
  base: {
    container: {
      hidden: false,
      opacity: '{a_17}',
      width: '{a_0}',
      height: '{a_1}',
      display: 'flex',
      'flex-direction': '{a_2}',
      'justify-content': '{a_3}',
      'align-items': '{a_4}',
      'background-color': '{a_5}',
      'border-radius': '{a_6}',
      'border-width': '{a_7}',
      'border-color': '{a_8}'
    },
    jds_image: {
      hidden: true,
      aspectRatio: 'round'
    },
    'jds-text': {
      'font-family': '{text_132}',
      color: '{text_41}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    },
    'jds-icon': {
      size: '{icon_24}',
      color: '{icon_7}',
      value: 'ic_profile',
      hidden: false,
      ic: 'ic_profile'
    },
    'jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_23}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}',
      hidden: false,
      ic: 'ic_profile'
    }
  },
  variant: {
    size: {
      'xtra-small': {
        container: {
          width: '{a_9}',
          height: '{a_10}'
        },
        'jds-text': {
          'font-family': '{text_167}',
          'font-size': '{text_166}',
          'line-height': '{text_168}',
          'letter-spacing': '{text_169}',
          'font-weight': '{text_170}'
        },
        'jds-icon': {
          size: '{icon_22}'
        },
        'jds-icon-container': {
          size: '{icon_21}'
        }
      },
      small: {
        container: {
          width: '{a_11}',
          height: '{a_12}'
        },
        'jds-text': {
          'font-family': '{text_167}',
          'font-size': '{text_166}',
          'line-height': '{text_168}',
          'letter-spacing': '{text_169}',
          'font-weight': '{text_170}'
        },
        'jds-icon': {
          size: '{icon_5}'
        },
        'jds-icon-container': {
          size: '{icon_2}'
        }
      },
      large: {
        container: {
          width: '{a_13}',
          height: '{a_14}'
        },
        'jds-text': {
          'font-family': '{text_117}',
          'font-size': '{text_116}',
          'line-height': '{text_118}',
          'letter-spacing': '{text_119}',
          'font-weight': '{text_120}'
        },
        'jds-icon': {
          size: '{icon_26}'
        },
        'jds-icon-container': {
          size: '{icon_25}'
        }
      },
      'xtra-large': {
        container: {
          width: 56,
          height: 56
        },
        'jds-text': {
          'font-family': '{text_117}',
          'font-size': '{text_116}',
          'line-height': '{text_118}',
          'letter-spacing': '{text_119}',
          'font-weight': '{text_120}'
        },
        'jds-icon': {
          size: '{icon_28}'
        },
        'jds-icon-container': {
          size: '{icon_27}'
        }
      },
      'xtra-xtra-large': {
        container: {
          width: '{a_15}',
          height: '{a_16}'
        },
        'jds-text': {
          'font-family': '{text_102}',
          'font-size': '{text_101}',
          'line-height': '{text_103}',
          'letter-spacing': '{text_104}',
          'font-weight': '{text_105}'
        },
        'jds-icon': {
          size: '{icon_28}'
        },
        'jds-icon-container': {
          size: '{icon_27}'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{a_18}'
        }
      }
    },
    isClickable: {
      false: {
        container: {
          disabled: true
        }
      }
    },
    kind: {
      image: {
        jds_image: {
          hidden: false
        },
        'jds-icon': {
          hidden: true
        },
        'jds-icon-container': {
          hidden: true
        },
        'jds-text': {}
      },
      initials: {
        container: {
          'background-color': '{a_19}'
        },
        jds_image: {
          hidden: true
        },
        'jds-icon': {
          hidden: true
        },
        'jds-icon-container': {
          hidden: true
        },
        'jds-text': {
          hidden: false
        }
      }
    }
  },
  combination: [
    {
      true: {
        icon: {
          container: {
            behavior: {
              focus: {
                'border-width': '{a_20}'
              }
            }
          },
          'jds-icon': {
            behavior: {
              hover: {
                color: '{icon_9}'
              },
              focus: {
                color: '{icon_9}'
              }
            }
          },
          'jds-icon-container': {
            behavior: {
              hover: {},
              focus: {}
            }
          }
        },
        initials: {
          container: {
            behavior: {
              hover: {
                'background-color': '{a_21}'
              },
              focus: {
                'border-width': '{a_22}',
                'background-color': '{a_23}'
              }
            }
          },
          'jds-text': {
            behavior: {
              hover: {
                color: '{text_40}'
              },
              focus: {
                color: '{text_40}'
              }
            }
          }
        },
        image: {
          container: {
            behavior: {
              hover: {
                opacity: '{a_24}'
              },
              focus: {
                'border-width': '{a_25}',
                opacity: '{a_26}'
              }
            }
          }
        }
      }
    }
  ],
  combination_config: [['isClickable', 'kind']],
  api: {
    data: {
      jds_image: {
        src: {
          type: 'image',
          name: 'image',
          doc_description:
            'This is a user uploaded image. It will be used, when [kind] is set to image.'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'initials',
          function: true,
          doc_description:
            'This is the two initials of user name. It will be used, when [kind] is set to initials.'
        }
      }
    },
    config: {
      size: {
        values: [
          'medium',
          'xtra-small',
          'small',
          'large',
          'xtra-large',
          'xtra-xtra-large'
        ],
        doc_description: 'This can be used to control the size of Avatar.'
      },
      kind: {
        values: ['icon', 'initials', 'image'],
        doc_description:
          'It can be used to switch between 3 variants of Avatar.'
      },
      disabled: {
        values: [false, true],
        doc_description: 'It can be used to enable or disable Avatar.'
      },
      isClickable: {
        values: [false, true],
        platform: 'web',
        doc_description: 'It can be used to make Avatar Clickable'
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'avatar'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
